import { render, staticRenderFns } from "./CompTextImageOverlap.vue?vue&type=template&id=249cdcd2"
import script from "./CompTextImageOverlap.vue?vue&type=script&lang=js"
export * from "./CompTextImageOverlap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports